import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { AppRoutingModule } from './app.routes';
import { AppComponent } from './app';
import { SharedModule } from './shared/shared.module';
import { GuidedTour } from './shared/components/guided-tour/guided-tour';
import { TourPrompt } from './shared/components/tour-prompt/tour-prompt';
import { JwtInterceptor } from './shared/interceptors/jwt.interceptor';
import { AuthenticationStore } from './shared/states/auth/auth.store';
import { hasPersistedSession } from './shared/utils/auth-session.util';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    GuidedTour,
    TourPrompt,
  ],
  providers: [
    provideStore({}),
    provideEffects([]),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (injector: Injector) => () => {
        if (!hasPersistedSession()) {
          return Promise.resolve();
        }
        return injector.get(AuthenticationStore).refreshSession();
      },
      deps: [Injector],
      multi: true,
    },
    MessageService,
    ConfirmationService,
    DialogService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark',
          cssLayer: false,
        },
      },
      ripple: true,
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
